/**
 * File: NewVersionBar.tsx
 * Path: apps/admin/src/modules/layout/components/NewVersionBar.tsx
 * Description: Keeps an open admin tab current. It asks /version.json which
 * build is live when the tab opens, when you come back to it, and every few
 * minutes. When a newer build is out it says so with a Reload button, and
 * the next page you open loads the new build by itself, so nothing typed is
 * lost mid-page and nothing stale lingers.
 */

import React from "react";
import { Button } from "@idk/ui";
import { ADMIN_VERSION } from "@/shared/utils/adminVersionUtils";
import { useNewVersionBarController } from "@/modules/layout/hooks/useNewVersionBarController";

export const NewVersionBar: React.FC<{ running?: string | null; fetcher?: typeof fetch }> = ({ running = ADMIN_VERSION, fetcher }) => {
  const { stale, reload } = useNewVersionBarController(running, fetcher);

  if (!stale) return null;
  return (
    <div role="status" className="flex flex-wrap items-center justify-between gap-stack-sm border-b border-primary bg-primary/10 px-gutter-md py-stack-xs text-sm">
      <span>A new version of the admin is ready. The next page you open loads it, or reload now.</span>
      <Button type="button" className="h-11 rounded-none" onClick={reload}>
        Reload now
      </Button>
    </div>
  );
};
